<template>
<div class="cont">
	<div class="ypjsbanner">
		<img src="../../assets/lhbanbj.jpg"/>
	</div>
	<div class="section">
		<div class="top"><img src="../../assets/lh.png"/></div>
		<div class="title">燕铺介绍</div>
		<p class="title_p">燕铺燕窝源自印尼 | 高品质燕窝发源地</p>
		<div class="title_box"><img src="../../assets/lhypywcd.jpg"/></div>
		<div class="sectcont">
			在印度尼西亚的加里曼丹岛</br>
一望无尽的雨林里栖息着全世界超多的金丝燕</br>
这里是金丝燕的天堂也是燕铺燕盏的出产地</br>
1000栋自有燕屋，长期打理清洁的燕屋</br>
无污染的燕屋建材，专业的检测和严苛的卫生要求</br>
在保证品质供应的同时，坚守着安全、营养、卫生的原则</br>
一切的高标准的背后，都源于燕铺对孕妈和宝宝的用心与坚持
		</div>
	</div>
	<div class="zygy">
		<div class="zygy_title"><img src="../../assets/lhzygy.jpg"/></div>
		<p class="zygy_p">
			印尼燕窝行业历史悠久，有更多行业经验，形成完整的燕窝生产流程</br>
原生原盏，天然本色，无论燕窝的外形和色泽都以天然的方式呈现给顾客
		</p>
		<ul>
			<li><span>极轻毛燕</span>
			<p><span>燕铺选用极轻毛燕</span>
<span>燕窝干净纯粹、无杂质</span>
<span>全程干挑保留营养不流失</span></p>
			</li>
			<li><span>手工挑毛</span>
			<p><span>古法手工挑毛</span>
<span>平均每盏手工挑选近百次</span>
<span>洁净度高、保留燕窝天然本质</span></p>
			</li>
			<li><span>干燥定性</span>
			<p><span>自然风干定性</span>
<span>干燥度高、轻折易碎</span>
<span>不为多余水分买单</span></p>
			</li>
		</ul>
	</div>
	<div class="aqyz">
		<div class="aqyz_title"><img src="../../assets/aqyz.jpg"/></div>
		<p>
			<span>0漂白：</span>原生色泽，拒绝化学染剂</br>
<span>0刷胶：</span>天然小缝隙，2-4小时易泡发</br>
<span>0粘碎：</span>保证每盏燕窝完整度，拒绝以次充好
		</p>
		
	</div>
	<div class="yzjk">
		<div class="title_box"><img src="../../assets/yzjk.jpg"/></div>
		<p>燕铺燕窝的每盏燕窝都标有CAIQ溯源码标签</br>
一盏一码，每盏燕窝都有迹可循</p>
<img src="../../assets/lhywcx.jpg"/>
<p style="letter-spacing: 5px">产地信息可查询 | <span>进口保障</span></br>
  检疫信息可查询 | <span>安心保障</span></br>
  进口信息可查询 | <span>正品保障</span></p>
	</div>
	<div class="bottom">
		<img src="../../assets/lhyanpu.jpg"/>
		<p>为\新\时\代\女\性\做\优\质\好\燕\窝</p>
	</div>
</div>
</template>

<script>
	
export default {
  name: 'mystar',
  data () {
    return {
      
    }
  },
  methods:{
			
		}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cont {
    width: 1120px;
    margin: 0 auto;
    height: 100%;
}
.ypjsbanner{ width: 100%; margin-bottom: 125px;}
.ypjsbanner img{ width: 100%;}
.section .top{ width: 100%; text-align: center;}
.section .top img{ width: 711px; height: 32px;}
.title{ line-height: 110px; color: #706d6d; font-size: 45px;letter-spacing: 15px}
.title_p{ font-size: 25px; color: #000;letter-spacing: 5px}
.title_box{ width: 395px; height: 54px; margin:52px auto;}
.sectcont{ line-height: 60px; font-size: 22px; background: url(../../assets/lhjsbj.jpg) no-repeat center bottom;padding-bottom: 470px;}
.zygy_title{ width: 395px; height: 54px; margin:52px auto;}
.zygy_p{font-size: 23px; line-height: 65px;}
.zygy ul{ display: flex; justify-content: center; list-style: none; margin: 95px auto;}
.zygy ul li{ width: 33.33%}
.zygy ul li>span{background: url(../../assets/lhico.jpg) no-repeat center center; width: 174px; height: 174px; font-size: 30px; display: block; margin:0 auto 15px; line-height: 174px; text-align: center;}
.zygy ul p{font-size: 23px; line-height: 42px;}
.zygy ul p span{ display: block}
.aqyz_title{ width: 395px; height: 54px; margin:0 auto 52px;}
.aqyz p{ font-size: 23px; line-height: 48px;}
.aqyz p span,.yzjk p span{ font-weight: bold;}
.yzjk p{ font-size: 23px; line-height: 55px;}
.bottom{ padding: 63px 0;}
.bottom img{ width: 150px; height: 66x;}
.bottom p{ font-size: 27px; line-height: 60px; letter-spacing: 5px; padding-top: 30px}
@media(max-width: 750px) {
   .cont{width:100%; margin: 0 auto;}
   .ypjsbanner{ width: 100%; overflow: hidden;margin-bottom:75px;}
   .ypjsbanner img{ width: 160%; margin-left: -30%;}
.section .top img{ width: 601px}
.zygy{ width: 690px; margin: 0 auto;}
.zygy ul p span{ display: inline}
}     

</style>



// WEBPACK FOOTER //
// src/components/story/ypjs.vue